<ng-container *ngIf="useBanta">
    <h1>Conversation</h1>
    <banta-comments 
        topicID="{{identifier}}_comments"
        (signInSelected)="showSignIn()"
        [maxMessages]="2000"
        [maxVisibleMessages]="200"
        (permissionDeniedError)="showPermissionDenied()"
        (editAvatarSelected)="editAvatar()"
        (reported)="reportMessage($event)"
        permissionDeniedLabel="Become a Member to Comment"
        ></banta-comments>
</ng-container>
<ng-container *ngIf="!useBanta">
    <tyt-spotim [identifier]="identifier"></tyt-spotim>
</ng-container>